import React from "react"
import { useSelector } from "react-redux"

import { FIT, SCIENTIFIC, FIT_RATIO } from "const"
import { StoreType } from "client/store"
import { NotUsed } from "client/components"

interface FormatedResultProps {
    data: string | number
}

const FormatedResult = ({
    data,
}: FormatedResultProps) => {
    const value = typeof data === "string"
        ? parseFloat(data)
        : data

    const format = useSelector((state: StoreType) => state.qidResult.format)
    const decimal = useSelector((state: StoreType) => state.qidResult.decimal)
    const lang = useSelector((state: StoreType) => state.system.lang)

    if (value === null) return <NotUsed />

    let formattedValue: string = null
    if (format === SCIENTIFIC) {
        formattedValue = value.toExponential(decimal)
    }
    if (format === FIT) {
        const fitValue = (value * FIT_RATIO).toFixed(decimal)
        formattedValue = `${fitValue} ${lang.fit}`
    }

    return <span>{formattedValue}</span>
}
export default FormatedResult
